import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import { useAction, useProgressSuccess } from 'hooks';
import { AppContext } from 'context';
import * as selectors from '../../selectors';
const usePatientSetupEffects = (externalReturnUrl)=>{
    const { externalRedirect } = useContext(AppContext);
    const countrySettings = useSelector(Account.selectors.countrySettings);
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const walletEntriesList = useSelector(Account.selectors.walletEntriesList);
    const isInProgress = useSelector(selectors.isPatientSetupProgress);
    const hasError = useSelector(selectors.hasPatientSetupErrors);
    const goToAid = useAction(App.actions.goToAid);
    const authorizeCloudDrive = useAction(CloudDrive.actions.authorize);
    const hasCentralStorage = !!walletEntriesList.find((entry)=>entry.serviceName === 'CentralStorage');
    const isPayerMandatory = countrySettings ? countrySettings.isPayerMandatory : false;
    const redirect = ()=>{
        const decodedUrl = decodeURIComponent(externalReturnUrl);
        if (decodedUrl) {
            externalRedirect(decodedUrl);
        } else {
            goToAid('mobile/host', null);
        }
    };
    useEffect(()=>{
        if (!hasCentralStorage && (!patientProfile || !patientProfile.encryptedExchangeToken)) {
            authorizeCloudDrive('CentralStorage', 'pwd');
        } else if (patientProfile && patientProfile.encryptedExchangeToken) {
            redirect();
        }
    }, []);
    useProgressSuccess(isInProgress, hasError, redirect);
    return {
        hasCentralStorage,
        isPayerMandatory
    };
};
export default usePatientSetupEffects;
